var _style, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 887 454",
    width: 887,
    height: 454,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none } \n\t\t.s1 { fill: #05386b } \n\t\t.s2 { fill: #12d488 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ee-background",
    fillRule: "evenodd",
    className: "s0",
    d: "m0 0h886.6v453.1h-886.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "element-id-73658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "element-id-68322",
    className: "s1",
    d: "m58 447.4c26.6 0 49.3-22.8 49.3-49.3v-50.7h-14.7v50c0 19.5-15.8 35.3-35.3 35.3h-50.2v14.7zm19.8-100h-20.5v14.7h20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-31513",
    className: "s1",
    d: "m136.1 347.4h-14.7v100h14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-53185",
    className: "s1",
    d: "m236.6 447.4h13.8v-100h-14.8v77.2l-70.7-77.2h-14.7v14.7h8.4zm-71.7-56.8h-14.7v56.8h14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-25050",
    className: "s1",
    d: "m376.7 381.5c1.1 13.4 11.5 23.9 25.2 23.9h49.8c5.5 0 10.4 3.2 10.4 9.1v7.8c0 5.6-4.7 10.4-10.4 10.4h-172.5v-27.3h70.7v-14.8h-85.5v56.8h187.3c14 0 25.2-11.2 25.2-25.1v-7.8c0-14-11.5-23.9-25.2-23.9h-49.8c-5.2 0-9.6-4-10.3-9.1zm14.8-9c0.1-5.6 4.6-10.4 10.4-10.4h75v-14.7h-75c-14.2 0-24.8 11.2-25.2 25.1zm-26.7-25.1h-100.3v14.7h100.3zm-92.9 36.4c4.1 0 7.3-3.2 7.3-7.3 0-4.2-3.5-7.4-7.4-7.4-4 0-7.3 3.3-7.3 7.3 0 3.9 3.2 7.4 7.4 7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-44735",
    className: "s1",
    d: "m549.3 405.4v-14.8h-43.6v-43.2h-14.7v100h14.7v-42zm27.1-58v100h14.8v-100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-64222",
    className: "s1",
    d: "m775.7 372.5c0-13.9-11.3-25.1-25.2-25.1h-75v14.7h75c9.7 0 10.4 7.9 10.4 12.9 0 9.3-2.5 15.6-10.4 15.6h-75v56.8h14.7v-42h60.3c13.9 0 25.2-11.2 25.2-25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "element-id-25705",
    className: "s1",
    d: "m799 347.4h-16.3l42.7 100h16.3zm67.6 0l-26.6 62.1 8 19.4 34.9-81.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "element-id-58247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "element-id-53062",
    className: "s2",
    d: "m540.1 267q-13.1 22.7-39.3 22.7h-111.6q-26.2 0-39.3-22.7l-55.8-96.6q-13.1-22.7 0-45.4l55.8-96.6q13.1-22.7 39.3-22.7h111.6q26.2 0 39.3 22.7l55.8 96.6q13.1 22.7 0 45.4zm-39.4-253.2h-111.5q-21.6 0-32.3 18.7l-55.8 96.6q-10.8 18.6 0 37.3l55.8 96.6q10.7 18.7 32.3 18.7h111.5q21.6 0 32.4-18.7l55.7-96.6q10.8-18.7 0-37.3l-55.7-96.6q-10.8-18.7-32.4-18.7zm21.1 174.6c0.9 20.5-8.6 41.9-24.6 55.5-1.2 0.9-2.9 0.9-4.1 0l-135-101.7v13.6l123.1 92.9c0.3 0.3 0.6 0.6 0.9 1.1 0.3 0.6 0.6 1.8 0 2.7q-0.5 1.3-1.8 1.8c-7.1 3.3-15.1 5-23.4 5.6-0.9 0-1.5-0.3-2.4-0.9l-96.4-72.6v13.6l71.5 54c1.2 0.6 1.5 2.4 1.2 3.6-0.6 1.4-1.8 2.3-3.3 2.3h-6.8c-16 0-30.9-5-43-14.5l-24.9-19c-1.5-1.2-1.8-3.3-0.9-4.7 1.2-1.5 3.2-1.8 4.7-0.6l25.2 19c10.1 8 22.3 12.4 35.6 13l-64.6-48.6c-0.9-0.6-1.5-1.8-1.5-2.7v-22.3c0-1.1 0.6-2.3 1.8-2.9 1.1-0.6 2.6-0.3 3.5 0.3l101.2 76.2c5-0.6 9.8-1.5 14.2-3l-119.2-89.8c-0.9-0.6-1.5-1.8-1.5-2.7v-22.3c0-1.1 0.6-2.3 1.8-2.9 1.1-0.6 2.6-0.3 3.5 0.3l138.2 104.1c13.4-12.2 21.1-30.6 20.2-48.4l0.3-145.6c0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.2 1.5 3.2 3.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f2437deff040f9337eada5ca0ce804c.svg";
export { ForwardRef as ReactComponent };